import utils from '../../utils'
import NotifyMsg from './NotifyMsg'
import BinaryWriter from './BinaryWriter'
import BinaryReader from './BinaryReader'

/*
建立 Socket 连接：

    let sock = new ZJNotify.Socket('localhost', 80, 'tcp|udp');
    sock.on('open', function (e) {
   	    sock.send('GET / HTTP/1.1\r\nHost: localhost:8080\r\n\r\n');
    });

    sock.on('close', function (e) {
   	    console.log('close', e);
    });

    sock.on('error', function (e) {
   	    console.log('error', e);
    });

    sock.on('recv', function (e) {
   	    let s = e.data.toUTF8String();
   	    console.log(s);
   	    sock.close();
    });

    sock.open();
*/


const ATYP_IP4 = 1;    // eslint-disable-line
const ATYP_DOMAIN = 3; // eslint-disable-line
const ATYP_IP6 = 4;    // eslint-disable-line

const Socket = function() {
    this.$init.apply(this, arguments);
};

const pt = Socket.prototype;

utils.EventExtend.install(pt);

pt.$init = function(host, port, type) {
    this.host = host || this.host;
    this.port = port || this.port;
    this.type = type || this.type || 'tcp';
    this.connected = false;
    this.$ws = null;
    this.$events = {};
};

pt.getToken = function() {
    const global = window || {};
    const $notify = global.$notify;
    return $notify.getToken();
};

pt.getProxyUrl = function() {
    const global = window || {};
    const $notify = global.$notify;
    return $notify.getProxyUrl();
};

function readIPv4(reader) {
    let ip = '';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    ip += '.';
    ip += reader.readInt8();
    return ip;
}

function readIPv6(reader) {
    let ip = [];
    for (let i = 0; i < 8; i++) {
        let s = reader.readInt16().toString(16);
        for (let j = s.length; j < 4; j++) {
            s = '0' + s;
        }
        ip.push(s);
    }
    
    // 压缩 IPv6
    let z = [{
        cmp: ip[0],
        count: 1
    }];
    for (let i = 1; i < 8; i++) {
        if (ip[i] === '0000' && z[z.length - 1].cmp === '0000') {
            z[z.length - 1].count++;
        }
        else {
            z.push({
                cmp: ip[i],
                count: 1
            });
        }
    }

    let max = 0, index = -1;
    for (let i = 0; i < z.length; i++) {
        if (z[i].cmp === '0000') {
            if (z[i].count >= max) {
                max = z[i].count;
                index = i;
            }
        }
    }

    if (index != -1) {
        ip = [];
        for (let i = 0; i < z.length; i++) {
            if (i == index) {
                ip.push('');
            }
            else {
                for (let j = 0; j < z[i].count; j++) {
                    ip.push(z[i].cmp);
                }
            }
        }
    }

    return '[' + ip.join(':') + ']';
}

function readDomain(reader) {
    let len = reader.readInt8();
    let arr = [];
    reader.readBuffer(arr, 0, len);
    let ip = utils.utf8ByteArrayToString(arr);
    return ip;
}

pt.open = function() {
    const that = this;
    const url = that.getProxyUrl();
    if (!url) {
        console.error('No notify url');
        throw new Error('No notify url');
    }
    const ws = that.$ws = new WebSocket(url);
    ws.binaryType = 'arraybuffer';
    const onmsg = function(e) {
        if (!that.$ws) return;
        if (!that.connected) {
            const msg = NotifyMsg.parseFromArrayBuffer(e.data);
            const blk = (msg.blocks||[])[0] || [];
            const reader = new BinaryReader(blk.data||[]);
            let ver = reader.readInt8();
            let code = reader.readInt8();
            let rsv = reader.readInt8();
            let atyp = reader.readInt8();
            if (
                ver != 0x5  ||
                code != 0   ||
                rsv != 0x01 ||
                (atyp != ATYP_IP4 && atyp != ATYP_IP6 && atyp != ATYP_DOMAIN)
            ) {
                e = new Error('Failed to connect ' + that.host + ':' + that.port);
                that.$emit('error', {
                    name: 'error',
                    error: e
                });
            }
            else {
                const ip = 
                    atyp == ATYP_IP4 ? readIPv4(reader) :
                    atyp == ATYP_IP6 ? readIPv6(reader) :
                    atyp == ATYP_DOMAIN ? readDomain(reader) : '';
                const port = reader.readInt16();
                that.connected = true;
                that.$emit('open', {
                    name: 'open',
                    data: {
                        proxyIP: ip,
                        proxyPort: port
                    }
                });
            }
        }
        else {
            that.$emit('recv', {
                name: 'recv',
                data: e.data
            });
        }
    };
    const onopen = function() {
        console.debug('Connected ' + url);

        let data = [];
        const writer = new BinaryWriter(data);
        // 参考 SOCKS5 协议
        writer.writeInt8(0x05); // SOCKS 协议版本
        writer.writeInt8(0x01); // CONNECT 命令
        writer.writeInt8(0x01); // RSV 保留字段
        writer.writeInt8(ATYP_DOMAIN); // 地址类型
        const domain = utils.stringToUtf8ByteArray(that.host || "");
        writer.writeInt8(domain.length);
        writer.writeArrayBuffer(domain, 0, domain.length);
        writer.writeInt16(that.port || 0);

        const wsmsg = NotifyMsg.wrap('CONNECT', data, that.getToken());
        wsmsg.header.cmd = that.type == 'tcp' ? NotifyMsg.CMD_TCP_PIPE : NotifyMsg.CMD_UDP_PIPE;
        wsmsg.header.cmdParam = 0;
        const pkg = wsmsg.getArrayBuffer();
        ws.send(pkg);
    };
    const onclose = function() {
        that.$ws.removeEventListener('open', onopen);
        that.$ws.removeEventListener('close', onclose);
        that.$ws.removeEventListener('error', onerror);
        that.$ws.removeEventListener('message', onmsg);
        that.$emit('close', {
            name: 'close',
            data: null
        });
        that.$ws = null;
        that.connected = false;
    };
    const onerror = function(e) {
        console.error(e);
        that.$emit('error', {
            name: 'error',
            error: e
        });
    };

    ws.addEventListener('open', onopen);
    ws.addEventListener('close', onclose);
    ws.addEventListener('error', onerror);
    ws.addEventListener('message', onmsg);
};

pt.close = function() {
    if (this.$ws) {
        this.$ws.close();
    }
};

pt.send = function(buffer, offset, count) {
    if (typeof buffer === 'string') {
        buffer = utils.stringToUtf8ByteArray(buffer || '');
        offset = 0;
        count = buffer.length;
    }
    else {
        if (buffer instanceof ArrayBuffer) {
            buffer = new Uint8Array(buffer);
        }
        if (typeof offset === 'undefined') {
            offset = 0;
        }
        if (typeof count === 'undefined') {
            count = buffer.length - offset;
        }
    }
    
    const writer = new BinaryWriter(count);
    writer.writeArrayBufferOrByteArray(buffer, offset, count);
    const arrayBuffer = writer.buffer;
    this.$ws.send(arrayBuffer);
};

export default Socket;
